import React from 'react'
import { M_Table } from 'src/M_Components'

const country = ({ roles }) => {
  return (
    <M_Table entityName={'Country'} rolePermissions={roles} />
  )
}

export default country